var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "lpu-reviews d-flex flex-column",
      class: _setup.isMobile ? "ga-4" : "ga-6",
      attrs: { id: "otzivi", "data-qa": "lpu_reviews" },
    },
    [
      _setup.hasReviews
        ? [
            _c(
              "div",
              {
                attrs: {
                  itemprop: "aggregateRating",
                  itemscope: "",
                  itemtype: "https://schema.org/AggregateRating",
                },
              },
              [
                _c("meta", {
                  attrs: {
                    itemprop: "itemReviewed",
                    content: _setup.reviewedName,
                  },
                }),
                _vm._v(" "),
                _c("meta", {
                  attrs: {
                    itemprop: "ratingValue",
                    content: _setup.ratingValue,
                  },
                }),
                _vm._v(" "),
                _c("meta", {
                  attrs: { itemprop: "worstRating", content: "0" },
                }),
                _vm._v(" "),
                _c("meta", {
                  attrs: { itemprop: "bestRating", content: "100" },
                }),
                _vm._v(" "),
                _c("meta", {
                  attrs: {
                    itemprop: "ratingCount",
                    content: String(_vm.lpu.allrates),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _setup.isMobile
                  ? "d-flex flex-column ga-4"
                  : "d-flex align-center justify-space-between",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "d-flex",
                    class: _setup.isMobile
                      ? "flex-column ga-5"
                      : "align-center ga-5",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center",
                        class: {
                          "justify-space-between w-100": _setup.isMobile,
                        },
                      },
                      [
                        _c(
                          "h2",
                          {
                            staticClass: "lpu-section-title text--text",
                            class: _setup.isMobile ? "text-h6" : "text-h5",
                            attrs: {
                              "data-qa": "lpu_reviews_title",
                              "data-count": String(_vm.lpu.allrates),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_setup.tStatic("Отзывы")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _setup.showAllReviewsLink
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "text-body-2 primary--text text-decoration-underline",
                                attrs: {
                                  href: _setup.allReviewsUrl,
                                  "data-qa": "lpu_reviews_all",
                                  "data-reviews-list-yandex-goals":
                                    "reviews_list_click_show_all_reviews",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_setup.tStatic("Все отзывы")) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      _setup.CorePRG,
                      {
                        attrs: {
                          url: _setup.helpUrl,
                          "button-attrs": _setup.helpButtonAttrs,
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-body-1 primary--text text-decoration-underline",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _setup.tStatic("Как мы проверяем отзывы?")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _setup.isMobile
                          ? _c("span", {
                              staticClass:
                                "ui-icon-link-2 ui-icon-fz-smaller primary--text ml-1",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _setup.showPrsPlate || _setup.showLeaveReviewButton
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex",
                        class: _setup.isMobile
                          ? "flex-column ga-4"
                          : "align-center ga-4",
                      },
                      [
                        _setup.showPrsPlate
                          ? _c(_setup.ReviewsPrsPlate, {
                              attrs: { url: _setup.prsLandingUrl },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _setup.showLeaveReviewButton
                          ? _c(_setup.ReviewsLeaveBtn, {
                              attrs: { "lpu-id": _vm.lpu.id },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _setup.hasFraudMark ? _c(_setup.ReviewsFraudAlert) : _vm._e(),
            _vm._v(" "),
            _setup.showTags
              ? _c(_setup.ReviewsTags, {
                  attrs: {
                    tags: _setup.tags,
                    "redirect-pathname": _setup.ratesPath,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(_setup.ReviewsList, {
              attrs: {
                rates: _setup.rates,
                lpu: _vm.lpu,
                "is-expanded": _setup.isExpanded,
              },
              on: {
                expand: function ($event) {
                  _setup.isExpanded = true
                },
              },
            }),
            _vm._v(" "),
            _c(_setup.ReviewsBottom, {
              attrs: {
                allrates: _vm.lpu.allrates,
                "rates-count": _setup.rates.length,
                "lpu-id": _vm.lpu.id,
                "rates-path": _setup.ratesPath,
                "can-leave-review": _setup.canLeaveReviewAllowed,
                "is-expanded": _setup.isExpanded,
              },
              on: {
                expand: function ($event) {
                  _setup.isExpanded = true
                },
              },
            }),
          ]
        : [
            _c(
              "h2",
              {
                staticClass: "text--text",
                class: _setup.isMobile ? "text-h6" : "text-h5",
                attrs: { "data-qa": "lpu_reviews_title" },
              },
              [_vm._v("\n      " + _vm._s(_setup.tStatic("Отзывы")) + "\n    ")]
            ),
            _vm._v(" "),
            _c(_setup.ReviewsEmpty, {
              attrs: {
                "lpu-id": _vm.lpu.id,
                "lpu-name": _setup.reviewedName,
                "show-leave-button": _setup.showEmptyLeaveReviewButton,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }